import { PlessURL } from './pless-url';

/**
 * APIを定義するクラス
 */
export class PlessService {
  /**
   * 商品検索共通
   */
  static KYMW00: string = PlessURL.URL + 'KYMW00/';

  /**
   * 共通部品（カスタムコンボ等）
   */
  static KYMW02: string = PlessURL.URL + 'KYMW02/';

  /**
   * 商品検索
   */
  static KYMW03: string = PlessURL.URL + 'KYMW03/';

  /**
   * 取引先一覧
   */
  static KYMW04: string = PlessURL.URL + 'KYMW04/';

  /**
   * 紐付設定
   */
  static KYMW05: string = PlessURL.URL + 'KYMW05/';

  /**
   * 関連商品設定
   */
  static KYMW06: string = PlessURL.URL + 'KYMW06/';

  /**
   * 文字情報選択
   */
  static KYMW07: string = PlessURL.URL + 'KYMW07/';

  /**
   * 実績履歴
   */
  static KYMW08: string = PlessURL.URL + 'KYMW08/';

  /**
   * 商品企画メンテ
   */
  static KYMW09: string = PlessURL.URL + 'KYMW09/';

  /**
   * 組合員の声選択
   */
  static KYMW0A: string = PlessURL.URL + 'KYMW0A/';

  /**
   * 画像検索
   */
  static KYMW0B: string = PlessURL.URL + 'KYMW0B/';

  /**
   * 画像作成指示
   */
  static KYMW0C: string = PlessURL.URL + 'KYMW0C/';

  /**
   * 処理ログ
   */
  static KYMW0D: string = PlessURL.URL + 'KYMW0D/';

  /**
   * 使用ページ確認
   */
  static KYMW0E: string = PlessURL.URL + 'KYMW0E/';

  /**
   * グルーピング選択
   */
  static KYMW0F: string = PlessURL.URL + 'KYMW0F/';

  /**
   * CWS用共通
   */
  static KYMW50: string = PlessURL.URL + 'KYMW50/';

  /**
   * ログイン、トップ、ダッシュボード画面テスト用(ログイン情報)
   */
  static KYMW10: string = PlessURL.URL + 'KYMW10/';

  /**
   * 商品登録
   */
  static KYMW11: string = PlessURL.URL + 'KYMW11/';

  /**
   * サイクル設定
   */
  static KYMW12: string = PlessURL.URL + 'KYMW12/';

  /**
   * 企画書データ出力
   */
  static KYMW13: string = PlessURL.URL + 'KYMW13/';

  /**
   * コマ割
   */
  static KYMW14: string = PlessURL.URL + 'KYMW14/';

  /**
   * マーク・アイコンマスタ
   */
  static KYMW15: string = PlessURL.URL + 'KYMW15/';

  /**
   * 画像確認
   */
  static KYMW16: string = PlessURL.URL + 'KYMW16/';

  /**
   * 画像作成管理
   */
  static KYMW17: string = PlessURL.URL + 'KYMW17/';

  /**
   * 画像チェックリスト
   */
  static KYMW18: string = PlessURL.URL + 'KYMW18/';

  /**
   * 組合員の声管理
   */
  static KYMW19: string = PlessURL.URL + 'KYMW19/';

  /**
   * 物流項目一覧集計
   */
  static KYMW20: string = PlessURL.URL + 'KYMW20/';

  /**
   * 注文コード設定
   */
  static KYMW21: string = PlessURL.URL + 'KYMW21/';

  /**
   * OCRデータメール送信
   */
  static KYMW22: string = PlessURL.URL + 'KYMW22/';

  /**
   * 印刷会社用データ出力
   */
  static KYMW23: string = PlessURL.URL + 'KYMW23/';

  /**
   * ページパターン設定
   */
  static KYMW24: string = PlessURL.URL + 'KYMW24/';

  /**
   * ページネーション設定
   */
  static KYMW25: string = PlessURL.URL + 'KYMW25/';

  /**
   * Ｗ掲載リスト
   */
  static KYMW26: string = PlessURL.URL + 'KYMW26/';

  /**
   * 基版コピー・フェーズ管理
   */
  static KYMW27: string = PlessURL.URL + 'KYMW27/';

  /**
   * 週別部門別供給高GP予算
   */
  static KYMW28: string = PlessURL.URL + 'KYMW28/';

  /**
   * 農産フロント連携
   */
  static KYMW29: string = PlessURL.URL + 'KYMW29/';

  /**
   * 1物N価商品企画一覧
   */
  static KYMW30: string = PlessURL.URL + 'KYMW30/';

  /**
   * 1物N価商品企画点検リスト
   */
  static KYMW31: string = PlessURL.URL + 'KYMW31/';

  /**
   * 1物N価商品Ｗ掲載一覧
   */
  static KYMW32: string = PlessURL.URL + 'KYMW32/';

  /**
   * 1物N価商品Ｗ掲載点検リスト
   */
  static KYMW33: string = PlessURL.URL + 'KYMW33/';

  /**
   * 1物N価商品企画差分リスト
   */
  static KYMW34: string = PlessURL.URL + 'KYMW34/';

  /**
   * 1物N価商品Ｗ扱い点検リスト
   */
  static KYMW35: string = PlessURL.URL + 'KYMW35/';

  /**
   * 週次プロモーションマスタ商品計画表
   */
  static KYMW40: string = PlessURL.URL + 'KYMW40/';

  /**
   * 統一企画点検リスト
   */
  static KYMW41: string = PlessURL.URL + 'KYMW41/';

  /**
   * 商品マスタプルーフ
   */
  static KYMW42: string = PlessURL.URL + 'KYMW42/';

  /**
   * 商品DNA情報
   */
  static KYMW43: string = PlessURL.URL + 'KYMW43/';

  /**
   * ページ・台割編集
   */
  static KYMW44: string = PlessURL.URL + 'KYMW44/';

  /**
   * 特集マスタ
   */
  static KYMW45: string = PlessURL.URL + 'KYMW45/';

  /**
   * タグ管理
   */
  static KYMW46: string = PlessURL.URL + 'KYMW46/';

  /**
   * マルチコード設定
   */
  static KYMW47: string = PlessURL.URL + 'KYMW47/';

  /**
   * クロスコード設定
   */
  static KYMW48: string = PlessURL.URL + 'KYMW48/';

  /**
   * CWS商品
   */
  static KYMW51: string = PlessURL.URL + 'KYMW51/';

  /**
   * CWS商品企画
   */
  static KYMW52: string = PlessURL.URL + 'KYMW52/';

  /**
   * CWSカテゴリマスタ
   */
  static KYMW53: string = PlessURL.URL + 'KYMW53/';

  /**
   * CWSカテゴリマスタ
   */
  static KYMW54: string = PlessURL.URL + 'KYMW54/';

  /**
   * CWS画像メンテ
   */
  static KYMW55: string = PlessURL.URL + 'KYMW55/';

  /**
   * CWSアイコンマスタ
   */
  static KYMW56: string = PlessURL.URL + 'KYMW56/';

  /**
   * CWSマーク変換マスタ
   */
  static KYMW57: string = PlessURL.URL + 'KYMW57/';

  /**
   * CWS企画商品別カテゴリ設定一覧表
   */
  static KYMW58: string = PlessURL.URL + 'KYMW58/';

  /**
   * CWS企画商品一覧表
   */
  static KYMW59: string = PlessURL.URL + 'KYMW59/';

  /**
   * CWSカテゴリ変換マスタ
   */
  static KYMW68: string = PlessURL.URL + 'KYMW68/';

  /**
   * CWS使用画像一覧表
   */
  static KYMW60: string = PlessURL.URL + 'KYMW60/';

  /**
   * CWS画像指示一覧表
   */
  static KYMW61: string = PlessURL.URL + 'KYMW61/';

  /**
   * CWSファイル出力送信指示
   */
  static KYMW62: string = PlessURL.URL + 'KYMW62/';

  /**
   * CWS外部システム連携
   */
  static KYMW63: string = PlessURL.URL + 'KYMW63/';

  /**
   * CWS登録商品
   */
  static KYMW64: string = PlessURL.URL + 'KYMW64/';

  /**
   * タイムセールマスタ
   */
  static KYMW65: string = PlessURL.URL + 'KYMW65/';

  /**
   * 特別指示書
   */
  static KYMW66: string = PlessURL.URL + 'KYMW66/';

  /**
   * 校正紙
   */
  static KYMW67: string = PlessURL.URL + 'KYMW67/';

  /**
   * 新規商品提案
   */
  static KYMW69: string = PlessURL.URL + 'KYMW69/';

  /**
   * 表紙・特集掲載商品選定
   */
  static KYMW70: string = PlessURL.URL + 'KYMW70/';

  /**
  * 束ね企画回設定
  */
  static KYMW71: string = PlessURL.URL + 'KYMW71/';

  /**
   * 運営商品一覧
   */
  static KYMW72: string = PlessURL.URL + 'KYMW72/';

  /**
   * 注文単位値引クーポン一覧
   */
  static KYMW73: string = PlessURL.URL + 'KYMW73/';

  /**
   * 忘れず注文商品
   */
  static KYMW74: string = PlessURL.URL + 'KYMW74/';

  /**
   * 計画数確認
   */
  static KYMW75: string = PlessURL.URL + 'KYMW75/';

  /**
   * ユーザー管理
   */
  static KYMW90: string = PlessURL.URL + 'KYMW90/';

  /**
   * ログ検索
   */
  static KYMW91: string = PlessURL.URL + 'KYMW91/';

  /**
   * 企画回一覧情報
   */
  static KYMW92: string = PlessURL.URL + 'KYMW92/';

  /**
   * お知らせ編集
   */
  static KYMW93: string = PlessURL.URL + 'KYMW93/';

  /**
   * 外部システム連携
   */
  static KYMW94: string = PlessURL.URL + 'KYMW94/';

  static SERVICE = {
    /*
     * フィールド名    : 識別の為のID　※この名前を実行時に指定します
     * url            : APIのURL
     * method         : 'POST'もしくは'GET'を指定
     * contentType    : contentTypeを指定
     * showBusyCursor : 通信時に画面を操作不可にする場合はtrue
     */

    // ==========================================================================================
    //   共通部品のAPI
    // ==========================================================================================
    /**
     * ログアウト
     */
    Logout: {
      url: PlessService.KYMW10 + 'logout',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * マークコードリスト取得
     */
    KYMW00getMarkCodeList: {
      url: PlessService.KYMW00 + 'getMarkCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 企画支援会社情報取得
     */
    getPlanSupportCompanyInfo: {
      url: PlessService.KYMW00 + 'getPlanSupportCompanyInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  環境テーブル内容の取得
     */
    KYMW02getCommonSetting: {
      url: PlessService.KYMW02 + 'getCommonSetting',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  受注(コード)リスト取得
     */
    KYMW02getOrderList: {
      url: PlessService.KYMW02 + 'getOrderList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  受注コード期間マスタリスト取得
     */
    KYMW02getPeriodSeqList: {
      url: PlessService.KYMW02 + 'getPeriodSeqList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  生協グループ取得
     */
    KYMW02getCoopList: {
      url: PlessService.KYMW02 + 'getCoop',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  生協グループ取得
     */
    KYMW02getStudioMaster: {
      url: PlessService.KYMW02 + 'getStudioMaster',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  媒体取得
     */
    KYMW02getMediumList: {
      url: PlessService.KYMW02 + 'getMediumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 企画商品フラグ媒体区分一覧取得
     */
    KYMW02GetMediumListPlanGoodsFlag: {
      url: PlessService.KYMW02 + 'getMediumListPlanGoodsFlag',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * コマ割実施フラグ媒体区分一覧取得
     */
    KYMW02GetMediumListKomaFlag: {
      url: PlessService.KYMW02 + 'getMediumListKomaFlag',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  媒体ビュー一覧取得
     */
    KYMW02getVMediumList: {
      url: PlessService.KYMW02 + 'getVMediumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  媒体ビュー一覧取得
     */
    KYMW02getVMediumDutiesFormList: {
      url: PlessService.KYMW02 + 'getVMediumDutiesFormList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  部門(コード)リスト取得
     */
    KYMW02getClassList: {
      url: PlessService.KYMW02 + 'getClassList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  大分類(コード)リスト取得
     */
    KYMW02getLargeClassList: {
      url: PlessService.KYMW02 + 'getLargeClassList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  中分類(コード)リスト取得
     */
    KYMW02getMiddleClassList: {
      url: PlessService.KYMW02 + 'getMiddleClassList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  小分類(コード)リスト取得
     */
    KYMW02getSmallClassList: {
      url: PlessService.KYMW02 + 'getSmallClassList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  コードリスト取得
     */
    KYMW02getCodeList: {
      url: PlessService.KYMW02 + 'getCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  コードリスト取得
     */
    KYMW02getCodeDefinitionList: {
      url: PlessService.KYMW02 + 'getCodeDefinitionList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  特集(コード)リスト取得
    */
    KYMW02getFeatureList: {
      url: PlessService.KYMW02 + 'getFeatureList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  タグ(ID)コンボボックス取得
    */
    KYMW02getAllTagList: {
      url: PlessService.KYMW02 + 'getAllTagList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページ表示件数取得
     */
    KYMW02getPageCntList: {
      url: PlessService.KYMW02 + 'getPageCntList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページ情報取得
     */
    KYMW02getPageList: {
      url: PlessService.KYMW02 + 'getPageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文コード割当コード情報取得
     */
    KYMW02getOrderNumQuotaList: {
      url: PlessService.KYMW02 + 'getOrderNumQuotaList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    KYMW02getSellingAreaList: {
      url: PlessService.KYMW02 + 'getSellingAreaList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  NGワードチェック
     */
    KYMW02checkNgWords: {
      url: PlessService.KYMW02 + 'checkNgWords',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  指定ファイルの取得（ダウンロード）
     */
    KYMW02getSpecifiedFile: {
      url: PlessService.KYMW02 + 'getSpecifiedFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品企画カテゴリ(コード)リスト取得
     */
    KYMW02getCwsPlanCategoryList: {
      url: PlessService.KYMW02 + 'getCwsPlanCategoryList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコンリスト取得
     */
    KYMW02getIconList: {
      url: PlessService.KYMW02 + 'getIconList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  グルーピングリスト取得
     */
    KYMW02getGroupingList: {
      url: PlessService.KYMW02 + 'getGroupingList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画進捗管理情報リスト取得
     */
    KYMW02getCatalogProgressList: {
      url: PlessService.KYMW02 + 'getCatalogProgressList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク定義一覧を取得
     */
    KYMW02getMarkList: {
      url: PlessService.KYMW02 + 'getMarkList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  カテゴリ変換区分リストを取得
     */
    KYMW02getConvDivList: {
      url: PlessService.KYMW02 + 'getConvDivList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  プロモーションコードリスト取得
     */
    KYMW02getPromotionCodeList: {
      url: PlessService.KYMW02 + 'getPromotionCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ＤＮＡコードリスト取得
     */
    KYMW02getDnaInfoList: {
      url: PlessService.KYMW02 + 'getDnaInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  価格パターンリスト取得
    */
    KYMW02getPricePatternList: {
      url: PlessService.KYMW02 + 'KYMW02getPricePatternList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 列幅設定取得
     */
    getUserColumnWidthSettings: {
      url: PlessService.KYMW02 + 'getUserColumnWidthSettings',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 列幅設定登録
     */
    registUserColumnWidthSettings: {
      url: PlessService.KYMW02 + 'registUserColumnWidthSettings',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  候補リスト
     */
    getCandidateGoodsList: {
      url: PlessService.KYMW03 + 'getCandidateGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  候補リスト出力
     */
    makeCandidateGoodsFile: {
      url: PlessService.KYMW03 + 'makeCandidateGoodsFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集コード情報リスト取得
     */
    KYMW03GetFeatureCodeList: {
      url: PlessService.KYMW03 + 'getFeatureCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  取引先一覧
     */
    /**
     *  取引先一覧情報取得
     */
    getSupplierList: {
      url: PlessService.KYMW04 + 'getSupplierList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  紐付設定
     */
    /**
     *  紐付設定情報取得
     */
    getRelatedData: {
      url: PlessService.KYMW05 + 'getRelatedData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品情報取得
     */
    getGoodsData: {
      url: PlessService.KYMW05 + 'getGoodsData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  紐付設定情報登録
     */
    registRelatedData: {
      url: PlessService.KYMW05 + 'registRelatedData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  関連商品設定
     */
    /**
     * 対象関連Pコード商品情報取得
     */
    getTargetRelationPcodeGoodsInfo: {
      url: PlessService.KYMW06 + 'getTargetRelationPcodeGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 候補一覧情報情報取得（関連商品設定）
     */
    KYMW0600getCandidateListInfo: {
      url: PlessService.KYMW06 + 'getCandidateListInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 関連Pコード更新
     */
    updateRelationPcode: {
      url: PlessService.KYMW06 + 'updateRelationPcode',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品文字情報選択
     */
    getTextInfo: {
      url: PlessService.KYMW07 + 'getTextInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品文字情報登録
     */
    registTextInfo: {
      url: PlessService.KYMW07 + 'registTextInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW0800:実績履歴
     */
    /**
     *  PDFファイルコピー(サーバ間)
     */
    KYMW0800PdfFileCopy: {
      url: PlessService.KYMW08 + 'pdfFileCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  実績履歴取得
     */
    KYMW0800GetResultList: {
      url: PlessService.KYMW08 + 'getResultList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  実績履歴WORKテーブル削除
     */
    KYMW0800DeleteWorkTable: {
      url: PlessService.KYMW08 + 'deleteWorkTable',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  実績履歴リスト出力
     */
    KYMW0800MakeResultList: {
      url: PlessService.KYMW08 + 'makeResultList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  計画数自動セット
     */
    KYMW0800RegistPlanNum: {
      url: PlessService.KYMW08 + 'registPlanNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW09:商品企画メンテ
     */
    /**
     *  商品企画メンテ画面表示情報取得
     */
    getPlanGoodsMaintain: {
      url: PlessService.KYMW09 + 'getPlanGoodsMaintain',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声掲載履歴検索
     */
    getPublishVoiceHistory: {
      url: PlessService.KYMW09 + 'getPublishVoiceHistory',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  会員生協計画数取得
     */
    getCoopPlanNum: {
      url: PlessService.KYMW09 + 'getCoopPlanNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  次回案内取得
     */
    getNextGuide: {
      url: PlessService.KYMW09 + 'getNextGuide',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品企画マスタ変更確認
     */
    checkPlanGoods: {
      url: PlessService.KYMW09 + 'checkPlanGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  取引先取得
     */
    getPlanGoodsSupplier: {
      url: PlessService.KYMW09 + 'getSupplier',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  配達企画回取得
     */
    getDelivCatalogID: {
      url: PlessService.KYMW09 + 'getDelivCatalogID',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  変更管理テーブルをクリア
     */
    clearPlanGoodsChangeManage: {
      url: PlessService.KYMW09 + 'clearPlanGoodsChangeManage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  変更確認一覧取得
     */
    KYMW09getChangeItemList: {
      url: PlessService.KYMW09 + 'getChangeItemList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  変更確定一覧送信
     */
    KYMW09saveChangeFixation: {
      url: PlessService.KYMW09 + 'saveChangeFixation',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  変更管理テーブルRENEW送信
     */
    KYMW09renewPlanGoodsChangeManage: {
      url: PlessService.KYMW09 + 'renewPlanGoodsChangeManage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  業態別企画商品情報取得送信
     */
    KYMW09getDutiesDivPlanGoodsList: {
      url: PlessService.KYMW09 + 'getDutiesDivPlanGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  業態別企画商品情報更新送信
     */
    KYMW09updateDutiesDivPlanGoodsList: {
      url: PlessService.KYMW09 + 'updateDutiesDivPlanGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文コード割当確認一覧取得
     */
    KYMW09getOrderNumQuotaConfirmList: {
      url: PlessService.KYMW09 + 'getOrderNumQuotaConfirmList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文コード割当確認一覧出力
     */
    KYMW09outputOrderNumQuotaConfirmList: {
      url: PlessService.KYMW09 + 'outputOrderNumQuotaConfirmList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 媒体リスト取得
     */
    getSelectedNvalMediumList: {
      url: PlessService.KYMW09 + 'getSelectedNvalMediumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 商品会員生協供給価格取得
     */
    getGoodsSupplyPrice: {
      url: PlessService.KYMW09 + 'getGoodsSupplyPrice',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　Ｐコードリスト取得
     */
    getPcodeList0A: {
      url: PlessService.KYMW0A + 'getPcodeList0A',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声一覧取得
     */
    getMembersVoicePcodeList: {
      url: PlessService.KYMW0A + 'getMembersVoicePcodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声一覧取得
     */
    getMembersVoiceSearchList: {
      url: PlessService.KYMW0A + 'getMembersVoiceSearchList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声管理情報取得
     */
    getMembersVoiceData: {
      url: PlessService.KYMW0A + 'getMembersVoiceData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声掲載検索
     */
    getPublishVoiceData: {
      url: PlessService.KYMW0A + 'getPublishVoiceData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声管理情報更新
     */
    updateMembersVoiceData: {
      url: PlessService.KYMW0A + 'updateMembersVoiceData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声掲載情報登録
     */
    registPublishVoiceData: {
      url: PlessService.KYMW0A + 'registPublishVoiceData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声掲載履歴検索
     */
    getPublishVoiceHistory0A: {
      url: PlessService.KYMW0A + 'getPublishVoiceHistory0A',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　組合員の声データ取込み
     */
    uploadMembersVoiceData: {
      url: PlessService.KYMW0A + 'uploadMembersVoiceData',
      showBusyCursor: true,
    },

    /**
     *  組合員の声選択　ＮＧワードチェック
     */
    checkNgWords0A: {
      url: PlessService.KYMW0A + 'checkNgWords0A',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  デフォルト消費税情報取得
     */
    getDefaultConsumeTaxInfo: {
      url: PlessService.KYMW09 + 'getDefaultConsumeTaxInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  デフォルト消費税情報取得
     */
    getGuideInfo: {
      url: PlessService.KYMW09 + 'getGuideInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文コード割当コード一覧取得
     */
    getOrderNumQuotaCodeList: {
      url: PlessService.KYMW09 + 'getOrderNumQuotaCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  抽選商品プロモーション情報取得
     */
    getPlanGoodsLotteryPromotion: {
      url: PlessService.KYMW09 + 'getPlanGoodsLotteryPromotion',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ポイント交換商品プロモーション情報取得
     */
    getPlanGoodsPointExchangePromotion: {
      url: PlessService.KYMW09 + 'getPlanGoodsPointExchangePromotion',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  1物N価媒体プロモーション情報取得処理
     */
    getPlanGoodsNvalPromotion: {
      url: PlessService.KYMW09 + 'getPlanGoodsNvalPromotion',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  クーポン商品プロモーション情報取得
     */
    getPlanGoodsCouponPromotion: {
      url: PlessService.KYMW09 + 'getPlanGoodsCouponPromotion',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  曜日別当選数取得
     */
    getNumberOfUsers: {
      url: PlessService.KYMW09 + 'getNumberOfUsers',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  予約商品フラグ取得
     */
    getPreOrderFlag: {
      url: PlessService.KYMW09 + 'getPreOrderFlag',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  予約設定情報取得
     */
    getPreOrder: {
      url: PlessService.KYMW09 + 'getPreOrder',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画商品EC情報取得処理
     */
    getPlanGoodsEC: {
      url: PlessService.KYMW09 + 'getPlanGoodsEC',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  EC使用画像情報取得処理
     */
    getImageData: {
      url: PlessService.KYMW09 + 'getImageData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  在庫数情報取得処理
     */
    getStockInfo: {
      url: PlessService.KYMW09 + 'getStockInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  グルーピング情報取得処理
     */
    getGroupingInfo: {
      url: PlessService.KYMW09 + 'getGroupingInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  Webリンク情報取得処理
     */
    getWebLinkInfo: {
      url: PlessService.KYMW09 + 'getWebLinkInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  グルーピングコード一覧取得
     */
    KYMW09getGroupingList: {
      url: PlessService.KYMW09 + 'getGroupingList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  グルーピングデータ取得処理
     */
    getGroupingData: {
      url: PlessService.KYMW09 + 'getGroupingData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タグ一覧取得
     */
    KYMW09getTagList: {
      url: PlessService.KYMW09 + 'getTagList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  取り扱われていない生協情報取得
     */
    getNotUseCoop: {
      url: PlessService.KYMW09 + 'getNotUseCoop',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  取扱生協取得
     */
    getGoodsUseCoop: {
      url: PlessService.KYMW09 + 'getGoodsUseCoop',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコンコード取得
     */
    getIconData: {
      url: PlessService.KYMW09 + 'getIconData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 1物N価詳細情報ID採番取得
     */
    getNvalDetailId: {
      url: PlessService.KYMW09 + 'getNvalDetailId',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * クーポン商品連番採番取得
     */
    getCouponGoodsNo: {
      url: PlessService.KYMW09 + 'getCouponGoodsNo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW0C:画像作成指示
     */
    /**
     *  Pコード情報取得
     */
    KYMW0C00GetPCodeData: {
      url: PlessService.KYMW0C + 'getPCodeData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  取引先情報取得
     */
    KYMW0C00GetSupplierName: {
      url: PlessService.KYMW0C + 'getSupplierName',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像名情報取得
     */
    KYMW0C00GetImageName: {
      url: PlessService.KYMW0C + 'getImageName',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像作成管理画面表示情報取得
     */
    KYMW0C00GetImageInfo: {
      url: PlessService.KYMW0C + 'getImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像種別単位の登録上限件数を取得する
     */
    KYMW0C00GetImageTypeLimit: {
      url: PlessService.KYMW0C + 'getImageTypeLimit',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像作成管理画面表示情報取得
     */
    KYMW0C00GetImageGroupInfo: {
      url: PlessService.KYMW0C + 'getImageGroupInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像情報管理更新
     */
    KYMW0C00UpdateImageInfo: {
      url: PlessService.KYMW0C + 'updateImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像情報管理更新
     */
    KYMW0C00ReferenceImageFileUpload: {
      url: PlessService.KYMW0C + 'referenceImageFileUpload',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW0D00:①処理結果ログ取得
     */
    getLogProcessResult: {
      url: PlessService.KYMW0D + 'getLogProcessResult',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW0D00:②処理結果データ作成
     */
    makeLogData: {
      url: PlessService.KYMW0D + 'makeLogData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW0D00:③処理結果ログ削除
     */
    deleteLogProcessResult: {
      url: PlessService.KYMW0D + 'deleteLogProcessResult',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  使用ページ確認 使用状況取得取得
     */
    getChangeInfo: {
      url: PlessService.KYMW0E + 'getChangeInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  グルーピング選択
     */
    /**
     *  グルーピング一覧取得
     */
    getGroupingList: {
      url: PlessService.KYMW0F + 'getGroupingList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW5002:①画像リスト取得
     */
    KYMW50getImageList: {
      url: PlessService.KYMW50 + 'getImageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW5002:②使用履歴一覧取得
     */
    KYMW50getUseRecordList: {
      url: PlessService.KYMW50 + 'getUseRecordList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW5002:③使用履歴画像リスト取得
     */
    KYMW50getUseRecordImageList: {
      url: PlessService.KYMW50 + 'getUseRecordImageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW5002:④検索画像リスト取得
     */
    KYMW50getSearchImageList: {
      url: PlessService.KYMW50 + 'getSearchImageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW5002:⑤画像情報詳細取得
     */
    KYMW50getImageInfoDetail: {
      url: PlessService.KYMW50 + 'getImageInfoDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW5002:⑤EC使用画像登録
     */
    KYMW50registImageData: {
      url: PlessService.KYMW50 + 'registImageData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW5003:CWS候補リスト取得
     */
    getCwsGoodsList: {
      url: PlessService.KYMW50 + 'getCwsGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    //  ==========================================================================================
    //     画面のAPI
    //   ==========================================================================================
    /**
     *  KYMW10:トップ画面
     */
    /**
     *  トップ情報取得
     */

    executeLogin: {
      url: PlessService.KYMW10 + 'executeLogin',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    // mock + 現行バックエンド 併用ログイン
    oldLogin: {
      url: PlessService.KYMW10 + 'executeLogin.xml',
      method: 'POST',
      contentType: 'application/xml',
      showBusyCursor: false,
    },

    getInformation: {
      url: PlessService.KYMW10 + 'getInformation',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    getDashboardMessage: {
      url: PlessService.KYMW10 + 'getDashboardMessage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    getDashboardLockInfo: {
      url: PlessService.KYMW10 + 'getDashboardLockInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    releaseImageLock: {
      url: PlessService.KYMW02 + 'releaseImageLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    getInitTop: {
      url: PlessService.KYMW10 + 'getInitTop',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    getUserSupplierCodeList: {
      url: PlessService.KYMW10 + 'getUserSupplierCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    updateAssociatedCompanyId: {
      url: PlessService.KYMW10 + 'updateAssociatedCompanyId',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 認証済判定
     */
    checkAuthenticated: {
      url: PlessService.KYMW10 + 'checkAuthenticated',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },    

    /**
     * コープデリ認証（SP-initiated）
     */
    callSamlAuthorize: {
      url: PlessService.KYMW10 + 'callSamlAuthorize',
      method: 'GET',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 処理ログダウンロード
     */
    downloadResultLog: {
      url: PlessService.KYMW10 + 'downloadResultLog',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 処理ログパス取得
     */
    getResultLogPath: {
      url: PlessService.KYMW10 + 'getResultLogPath',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW11:商品登録画面
     */
    /**
     *  商品情報初期表示取得
     */
    getInitData: {
      url: PlessService.KYMW11 + 'getInitData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品情報登録
     */
    registGoods: {
      url: PlessService.KYMW11 + 'registGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品情報更新
     */
    updateGoods: {
      url: PlessService.KYMW11 + 'updateGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品情報取得
     */
    getGoodsBase: {
      url: PlessService.KYMW11 + 'getGoodsBase',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイテム情報取得
     */
    getGoodsDetail: {
      url: PlessService.KYMW11 + 'getGoodsDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  取引先情報取得
     */
    getSupplier: {
      url: PlessService.KYMW11 + 'getSupplier',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  JANコードインストア採番取得
     */
    getJANCode: {
      url: PlessService.KYMW11 + 'getJANCode',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品情報削除
     */
    deleteGoods: {
      url: PlessService.KYMW11 + 'deleteGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイテム情報削除
     */
    deleteGoodsDetail: {
      url: PlessService.KYMW11 + 'deleteGoodsDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品情報コピー
     */
    registGoodsBaseCopy: {
      url: PlessService.KYMW11 + 'registGoodsBaseCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品情報コピー
     */
    registGoodsDetailCopy: {
      url: PlessService.KYMW11 + 'registGoodsDetailCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  仕入価格計算
     */
    getPurchasePrice: {
      url: PlessService.KYMW11 + 'getPurchasePrice',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  消費税区分、消費税率取得
     */
    getConsumeTaxInfo: {
      url: PlessService.KYMW11 + 'getConsumeTaxInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  計算処理
     */
    getSupplyPlan: {
      url: PlessService.KYMW11 + 'getSupplyPlan',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ファイル出力処理
     */
    save3File: {
      url: PlessService.KYMW11 + 'save3File',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  新規取扱情報帳票出力日更新
     */
    updateReportOutputDate: {
      url: PlessService.KYMW11 + 'updateReportOutputDate',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 商品仕様取込み処理
     */
    registEBaseData: {
      url: PlessService.KYMW11 + 'registEBaseData',
      showBusyCursor: true,
    },

    /**
     *  KYMW1100: 商品マスタ画面
     *
     *  eBASE取込データ作成
     */
    createEBaseData: {
      url: PlessService.KYMW11 + 'createEBaseData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1100: 商品マスタ画面
     *
     *  eBASE一括取込
     */
    updateEBaseData: {
      url: PlessService.KYMW11 + 'updateEBaseData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1102:新規取扱商品画面
     */
    /**
     *  検索処理
     */
    getSelectInfo: {
      url: PlessService.KYMW11 + 'getSelectInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1103:eBase商品仕様反映画面
     */
    /**
     *  eBaseデータ取得
     */
    geteBaseData: {
      url: PlessService.KYMW11 + 'geteBaseData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    geteBaseNo: {
      url: PlessService.KYMW11 + 'geteBaseNo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1104:アイテム付替画面
     */
    /**
     *  ComboBox初期値取得
     */
    initItemCodeCombo: {
      url: PlessService.KYMW11 + 'initItemCodeCombo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getSelectedCodesForCoops: {
      url: PlessService.KYMW11 + 'getSelectedCodesForCoops',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    updateItemCodeForCoop: {
      url: PlessService.KYMW11 + 'updateItemCodeForCoop',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1105:eBASEデータ画面
     */
    /**
     *  商品仕様書マスタ情報取得
     */
    getGoodsSpecificationInfo: {
      url: PlessService.KYMW11 + 'getGoodsSpecificationInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品栄養成分情報一覧取得
     */
    getGoodsNutrientComponentList: {
      url: PlessService.KYMW11 + 'getGoodsNutrientComponentList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品栄養成分情報登録・更新
     */
    registNutrientInfo: {
      url: PlessService.KYMW11 + 'registNutrientInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    /**
     *  商品栄養成分情報削除
     */
    deleteNutrientComposition: {
      url: PlessService.KYMW11 + 'deleteNutrientComposition',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1108: 商品仕様取込画面
     *
     *  eBASE取込データ作成
     */
    getEbaseCandidateList: {
      url: PlessService.KYMW11 + 'getEbaseCandidateList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  KYMW12:サイクル設定
    */
    /**
     *  掲載媒体情報取得
     */
    getPublishMediumInfo: {
      url: PlessService.KYMW12 + 'getPublishMediumInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  掲載媒体設定更新
     */
    updatePublishMediumSetting: {
      url: PlessService.KYMW12 + 'updatePublishMediumSetting',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集コード一覧取得
     */
    getFeatureCodeList: {
      url: PlessService.KYMW12 + 'getFeatureCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  価格プロモーションリスト取得処理
     */
    getPricePromotionList: {
      url: PlessService.KYMW12 + 'getPricePromotionList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画回情報取得処理
     */
    KYMW12getCatalogInfo: {
      url: PlessService.KYMW12 + 'getCatalogInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画回別商品一覧情報取得
     */
    getPublishPlanGoodsCategoryListInfo: {
      url: PlessService.KYMW12 + 'getPublishPlanGoodsCategoryListInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル情報保存
     */
    saveCycleInfo: {
      url: PlessService.KYMW12 + 'saveCycleInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル情報登録
     */
    registCycleInfo: {
      url: PlessService.KYMW12 + 'registCycleInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画回別商品一覧表出力
     */
    outputPublishPlanGoodsCategoryListInfo: {
      url: PlessService.KYMW12 + 'outputPublishPlanGoodsCategoryListInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ノンブル取得
     */
    getFolio: {
      url: PlessService.KYMW12 + 'getFolio',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル企画商品クロス設定情報削除
     */
    deleteCyclePlanGoodsCross: {
      url: PlessService.KYMW12 + 'deleteCyclePlanGoodsCross',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定媒体選択項目取得
     */
    getCycleMediumSelectItems: {
      url: PlessService.KYMW12 + 'getCycleMediumSelectItems',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定表示条件取得
     */
    getCycleDispCondition: {
      url: PlessService.KYMW12 + 'getCycleDispCondition',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画未確定受注コード一覧取得
     */
    getNonFixedOrderList: {
      url: PlessService.KYMW12 + 'getNonFixedOrderList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  バイヤー選択項目取得
     */
    getBuyerSelectItems: {
      url: PlessService.KYMW12 + 'getBuyerSelectItems',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  WK実績履歴情報作成
     */
    registWkResultList: {
      url: PlessService.KYMW12 + 'registWkResultList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定予実情報取得
     */
    getCycleSummary: {
      url: PlessService.KYMW12 + 'getCycleSummary',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定予実変更差分取得
     */
    getCycleSummaryDiff: {
      url: PlessService.KYMW12 + 'getCycleSummaryDiff',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定商品情報取得
     */
    getCycleItemInfo: {
      url: PlessService.KYMW12 + 'getCycleItemInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定他媒体情報取得
     */
    getOtherMediums: {
      url: PlessService.KYMW12 + 'getOtherMediums',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定商品情報登録
     */
    registCycleItemInfo: {
      url: PlessService.KYMW12 + 'registCycleItemInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定表示条件情報登録
     */
    registCycleDispCondition: {
      url: PlessService.KYMW12 + 'registCycleDispCondition',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定商品表示順登録
     */
    registCycleSort: {
      url: PlessService.KYMW12 + 'registCycleSort',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  代行バイヤーコード取得
     */
    getBuyerCodeForAgent: {
      url: PlessService.KYMW12 + 'getBuyerCodeForAgent',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サイクル設定一覧表出力
     */
    outputCycleItemInfo: {
      url: PlessService.KYMW12 + 'outputCycleItemInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  配下バイヤー選択項目取得
     */
    getStaffBuyerSelectItems: {
      url: PlessService.KYMW12 + 'getStaffBuyerSelectItems',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  KYMW13:商品選定
    */
    /**
     *  企画書データ出力
     */
    getPlanCSV: {
      url: PlessService.KYMW13 + 'getPlanCSV',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 特集情報取得
     */
    getFeatureThemaList: {
      url: PlessService.KYMW13 + 'getFeatureThemaList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  掲載料請求データ出力
     */
    getPublishBillDataCSV: {
      url: PlessService.KYMW13 + 'getPublishBillDataCSV',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文コード割当取得
     */
    getOrderNumQuotaData: {
      url: PlessService.KYMW13 + 'getOrderNumQuotaData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  仕様確認表出力
     */
    outputSpecConfirmList: {
      url: PlessService.KYMW13 + 'outputSpecConfirmList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  業態別企画書データ出力
     */
    outPutPlanDutiesFormCSV: {
      url: PlessService.KYMW13 + 'outPutPlanDutiesFormCSV',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  束ね企画回情報一覧取得
     */
    getBundleCatalogRoundInfoList: {
      url: PlessService.KYMW13 + 'getBundleCatalogRoundInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  媒体一覧を取得
     */
    getPlanGoodsMedium: {
      url: PlessService.KYMW13 + 'getPlanGoodsMedium',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集コード一覧取得
     */
    KYMW13GetFeatureCodeList: {
      url: PlessService.KYMW13 + 'getFeatureCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1307:予算・計画・実績表
     */
    getSummaryTable: {
      url: PlessService.KYMW13 + 'getSummaryTable',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getCatalogInfo: {
      url: PlessService.KYMW13 + 'getCatalogInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getPlanTargetList: {
      url: PlessService.KYMW13 + 'getPlanTargetList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getOrderTargetList: {
      url: PlessService.KYMW13 + 'getOrderTargetList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getSearchTargetList: {
      url: PlessService.KYMW13 + 'getSearchTargetList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getSelectedList: {
      url: PlessService.KYMW13 + 'getSelectedList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getPlanNumList: {
      url: PlessService.KYMW13 + 'getPlanNumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    checkRegistPlan: {
      url: PlessService.KYMW13 + 'checkRegistPlan',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    registPlan: {
      url: PlessService.KYMW13 + 'registPlan',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    checkDeletePlan: {
      url: PlessService.KYMW13 + 'checkDeletePlan',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    deletePlan: {
      url: PlessService.KYMW13 + 'deletePlan',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    updateNextGuideAuto: {
      url: PlessService.KYMW13 + 'updateNextGuideAuto',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    updateNextGuideLump: {
      url: PlessService.KYMW13 + 'updateNextGuideLump',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    registLockInfoCatalog: {
      url: PlessService.KYMW13 + 'registLockInfoCatalog',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    deleteLockInfoCatalog: {
      url: PlessService.KYMW13 + 'deleteLockInfoCatalog',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    outputSelectedList: {
      url: PlessService.KYMW13 + 'outputSelectedList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    outputBundleMixMatch: {
      url: PlessService.KYMW13 + 'outputBundleMixMatch',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    outputSetPlanList: {
      url: PlessService.KYMW13 + 'outputSetPlanList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    checkPCode: {
      url: PlessService.KYMW13 + 'checkPCode',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    
    getNvalPeriodCSV: {
      url: PlessService.KYMW13 + 'getNvalPeriodCSV',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1308:バンドルミックスマッチ設定
     */
    getPromotionGoodsInfo: {
      url: PlessService.KYMW13 + 'getPromotionGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getPromotionNo: {
      url: PlessService.KYMW13 + 'getPromotionNo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    calcApprovedPrice: {
      url: PlessService.KYMW13 + 'calcApprovedPrice',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getPlanGoodsInfo: {
      url: PlessService.KYMW13 + 'getPlanGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    registPromotionGoods: {
      url: PlessService.KYMW13 + 'registPromotionGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1310:Ｗ掲載設定
     */
    getPlanMultiPublish: {
      url: PlessService.KYMW13 + 'getPlanMultiPublish',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    registPlanMultiPublish: {
      url: PlessService.KYMW13 + 'registPlanMultiPublish',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1312:セット企画設定
     */
    getSetPlanPromotionGoodsInfo: {
      url: PlessService.KYMW13 + 'getSetPlanPromotionGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getSetPlanPromotionNo: {
      url: PlessService.KYMW13 + 'getSetPlanPromotionNo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getSetPlanGoodsInfo: {
      url: PlessService.KYMW13 + 'getSetPlanGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    registSetPlanPromotionGood: {
      url: PlessService.KYMW13 + 'registSetPlanPromotionGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1313:セット企画検索
     */
    getSetPlanPromotionGoodsList: {
      url: PlessService.KYMW13 + 'getSetPlanPromotionGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    KYMW1300FileDownload: {
      url: PlessURL.URL,
      showBusyCursor: true,
    },

    /**
     *  KYMW1317:企画連絡承認
     */
    approvalItem: {
      url: PlessService.KYMW13 + 'approvalItem',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    getApprovalItemList: {
      url: PlessService.KYMW13 + 'getApprovalItemList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画メンテファイル取込
     */
    uploadPlanGoodsCopeFile: {
      url: PlessService.KYMW13 + 'uploadPlanGoodsCopeFile',
      showBusyCursor: true,
    },

    /**
     *  取扱生協CSVファイル取込
     */
    uploadCoopFile: {
      url: PlessService.KYMW13 + 'uploadCoopFile',
      showBusyCursor: true,
    },
    /**
     *  取扱生協CSVファイル取込
     */
    uploadProposalCarrotFile: {
      url: PlessService.KYMW13 + 'uploadProposalCarrotFile',
      showBusyCursor: true,
    },

    /**
     *  KYMW1317:受注コード指定選定解除
     */
    /**
     *  選定解除対象情報取得
     */
    getDeletePlanGoodsInfo: {
      url: PlessService.KYMW13 + 'getDeletePlanGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  選定解除企画商品情報削除
     */
    deletePlanGoodsInfo: {
      url: PlessService.KYMW13 + 'deletePlanGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1319: 特集付替設定
     */
    /**
     * 企画商品特集商品情報取得
     */
    getSelectedPlanGoodsFeatureList: {
      url: PlessService.KYMW13 + 'getSelectedPlanGoodsFeatureList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 特集情報取得
     */
    getFeatureThemaListForUpdate: {
      url: PlessService.KYMW13 + 'getFeatureThemaListForUpdate',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 企画商品特集商品情報更新
     */
    updatePlanGoodsFeature: {
      url: PlessService.KYMW13 + 'updatePlanGoodsFeature',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 特集用束ね企画情報取得
     */
    getBundleCatalogInfoForFeature: {
      url: PlessService.KYMW13 + 'getBundleCatalogInfoForFeature',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1320 1物N価商品点検リスト
     */
    /**
     * 1物N価商品点検リスト出力
     */
    saveInspectList: {
      url: PlessService.KYMW13 + 'saveInspectList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW14:コマ割
     */
    /**
     * KYMW1400:①ページ情報取得
     */
    KYMW14getPage: {
      url: PlessService.KYMW14 + 'getPage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:②計画値集計表取得
     */
    KYMW14getPlanSummaryTable: {
      url: PlessService.KYMW14 + 'getPlanSummaryTable',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:③コマ情報取得
     */
    KYMW14getKoma: {
      url: PlessService.KYMW14 + 'getKoma',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:④コマ情報登録
     */
    KYMW14registKoma: {
      url: PlessService.KYMW14 + 'registKoma',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑤コマ商品情報登録
     */
    KYMW14registKomaGoods: {
      url: PlessService.KYMW14 + 'registKomaGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑥商品情報登録
     */
    KYMW14registGoods: {
      url: PlessService.KYMW14 + 'registGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑦コマ情報更新
     */
    KYMW14updateKoma: {
      url: PlessService.KYMW14 + 'updateKoma',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑧コマ情報削除
     */
    KYMW14deleteKoma: {
      url: PlessService.KYMW14 + 'deleteKoma',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑨コマ情報全削除
     */
    KYMW14deleteAllKoma: {
      url: PlessService.KYMW14 + 'deleteAllKoma',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑩コマ割情報ロック
     */
    KYMW14lockKomaEdit: {
      url: PlessService.KYMW14 + 'lockKomaEdit',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑬注文コードSEQNo.一括設定
     */
    KYMW14setOrderNumSeqNo: {
      url: PlessService.KYMW14 + 'setOrderNumSeqNo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑮組合員の声掲載削除
     */
    KYMW14deletePublishVoice: {
      url: PlessService.KYMW14 + 'deletePublishVoice',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑯コマ入替
     */
    KYMW14replaceKoma: {
      url: PlessService.KYMW14 + 'replaceKoma',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:⑰コマ詰め
     */
    KYMW14shiftKoma: {
      url: PlessService.KYMW14 + 'shiftKoma',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1400:コマ割媒体取得
     */
    KYMW14getKomaMediumList: {
      url: PlessService.KYMW14 + 'getKomaMediumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1402:①誌面印刷ページデータ取得
     */
    getPrintPageData: {
      url: PlessService.KYMW14 + 'getPrintPageData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1402:②コマ割誌面印刷データ取得
     */
    getKomaPrintData: {
      url: PlessService.KYMW14 + 'getKomaPrintData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 掲載商品検索
     */
    getPublishGoodsData: {
      url: PlessService.KYMW14 + 'getPublishGoodsData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 掲載候補商品リスト
     */
    getNominationGoodsData: {
      url: PlessService.KYMW14 + 'getNominationGoodsData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getSellingAreaList: {
      url: PlessService.KYMW14 + 'getSellingAreaList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:①画像リスト取得
     */
    KYMW14getImageList: {
      url: PlessService.KYMW14 + 'getImageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:②使用履歴一覧取得
     */
    KYMW14getUseRecordList: {
      url: PlessService.KYMW14 + 'getUseRecordList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:③使用履歴画像リスト取得
     */
    KYMW14getUseRecordImageList: {
      url: PlessService.KYMW14 + 'getUseRecordImageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:④検索画像リスト取得
     */
    KYMW14getSearchImageList: {
      url: PlessService.KYMW14 + 'getSearchImageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:⑤画像情報詳細取得
     */
    KYMW14getImageInfoDetail: {
      url: PlessService.KYMW14 + 'getImageInfoDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:⑥使用画像登録
     */
    KYMW14registUseImage: {
      url: PlessService.KYMW14 + 'registUseImage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:⑦使用画像更新
     */
    KYMW14updateUseImage: {
      url: PlessService.KYMW14 + 'updateUseImage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:⑧画像情報管理更新
     */
    KYMW14updateImageInfo: {
      url: PlessService.KYMW14 + 'updateImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW1407:⑨画像情報管理使用停止更新
     */
    KYMW14updateImageInfoEnabled: {
      url: PlessService.KYMW14 + 'updateImageInfoEnabled',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW1407:画像ファイルダウンロード）
     */
    KYMW14GetImageFileDownload: {
      url: PlessURL.URL,
      showBusyCursor: true,
    },

    /**
     * マーク指示
     */
    getMarkList: {
      url: PlessService.KYMW14 + 'getMarkList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    registUseMark: {
      url: PlessService.KYMW14 + 'registUseMark',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    deleteUseMark: {
      url: PlessService.KYMW14 + 'deleteUseMark',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 商品情報
     */
    getGoodsInfoList: {
      url: PlessService.KYMW14 + 'getGoodsInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    updateGoodsInfo: {
      url: PlessService.KYMW14 + 'updateGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getCrossMulti: {
      url: PlessService.KYMW14 + 'getCrossMulti',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getDistributionItemSummaryData: {
      url: PlessService.KYMW20 + 'getDistributionItemSummaryData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getCycleMediumList: {
      url: PlessService.KYMW20 + 'getCycleMediumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getCycleTempSelectedSummary: {
      url: PlessService.KYMW20 + 'getCycleTempSelectedSummary',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getCycleTempSelectedSummaryByBuyer: {
      url: PlessService.KYMW20 + 'getCycleTempSelectedSummaryByBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getCycleOrderNumQuotaSelectedSummary: {
      url: PlessService.KYMW20 + 'getCycleOrderNumQuotaSelectedSummary',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    outputCycleOrderNumQuotaSelectedSummary: {
      url: PlessService.KYMW20 + 'outputCycleOrderNumQuotaSelectedSummary',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getPlanTempSelectedSummary: {
      url: PlessService.KYMW20 + 'getPlanTempSelectedSummary',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getPlanTempSelectedSummaryByBuyer: {
      url: PlessService.KYMW20 + 'getPlanTempSelectedSummaryByBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    getPlanOrderNumQuotaSelectedSummary: {
      url: PlessService.KYMW20 + 'getPlanOrderNumQuotaSelectedSummary',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    outputPlanOrderNumQuotaSelectedSummary: {
      url: PlessService.KYMW20 + 'outputPlanOrderNumQuotaSelectedSummary',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    /**
     * W掲載元(親)設定
     */
    getParentChildPage: {
      url: PlessService.KYMW14 + 'getParentChildPage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    updateParentChildDiv: {
      url: PlessService.KYMW14 + 'updateParentChildDiv',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  KYMW15:マーク・アイコンマスタ画面
     */
    /**
     *  マークグループ一覧取得
     */
    getMarkGroupList: {
      url: PlessService.KYMW15 + 'getMarkGroupList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  販売促進マーク区分一覧取得
     */
    getSupplyPromoteMarkDivList: {
      url: PlessService.KYMW15 + 'getSupplyPromoteMarkDivList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  登録可能マークファイル一覧取得
     */
    getMarkFileList: {
      url: PlessService.KYMW15 + 'getMarkFileList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マークファイル情報検索
     */
    getMarkFile: {
      url: PlessService.KYMW15 + 'getMarkFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク情報登録
     */
    registMark: {
      url: PlessService.KYMW15 + 'registMark',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク情報削除
     */
    deleteMark: {
      url: PlessService.KYMW15 + 'deleteMark',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マークファイル登録
     */
    registMarkFile: {
      url: PlessService.KYMW15 + 'registMarkFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マークファイル活性区分変更
     */
    updateMarkFileEnabled: {
      url: PlessService.KYMW15 + 'updateMarkFileEnabled',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マークファイル情報削除
     */
    deleteMarkFile: {
      url: PlessService.KYMW15 + 'deleteMarkFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マークファイル適用期間修正
     */
    updateMarkFilePeriod: {
      url: PlessService.KYMW15 + 'updateMarkFilePeriod',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マークファイル適用期間登録
     */
    registMarkFilePeriod: {
      url: PlessService.KYMW15 + 'registMarkFilePeriod',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク画像出力
     */
    getMarkImageDownload: {
      url: PlessService.KYMW15 + 'getMarkImageDownload',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク掲載順一覧取得
     */
    getMarkPublishOrderList: {
      url: PlessService.KYMW15 + 'getMarkPublishOrderList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク掲載順更新
     */
    updateMarkPublishOrder: {
      url: PlessService.KYMW15 + 'updateMarkPublishOrder',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコン情報一覧取得
     */
    getCwsIconData: {
      url: PlessService.KYMW15 + 'getCwsIconData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコン情報削除
     */
    deleteCwsIconFileData: {
      url: PlessService.KYMW15 + 'deleteCwsIconFileData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク変換情報取得
     */
    getMarkConvInfo: {
      url: PlessService.KYMW15 + 'getMarkConvInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコン変換情報取得
     */
    getCwsIconConvInfo: {
      url: PlessService.KYMW15 + 'getCwsIconConvInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マーク変換情報更新
     */
    updateCwsMarkConv: {
      url: PlessService.KYMW15 + 'updateCwsMarkConv',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコン変換情報更新
     */
    updateCwsIconConv: {
      url: PlessService.KYMW15 + 'updateCwsIconConv',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコン情報登録
     */
    registCwsIconData: {
      url: PlessService.KYMW15 + 'registCwsIconData',
      showBusyCursor: true,
    },

    /**
     *  CWSアイコン基本情報取得
     */
    getCwsIconBaseData: {
      url: PlessService.KYMW15 + 'getCwsIconBaseData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  別アイコンファイル情報登録
     */
    registCwsIconFileData: {
      url: PlessService.KYMW15 + 'registCwsIconFileData',
      showBusyCursor: true,
    },

    /**
     *  アイコン情報更新
     */
    updateCwsIconData: {
      url: PlessService.KYMW15 + 'updateCwsIconData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコン掲載順一覧取得
     */
    getCwsIconPublishOrderList: {
      url: PlessService.KYMW15 + 'getCwsIconPublishOrderList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  アイコン掲載順更新
     */
    updateCwsIconPublishOrder: {
      url: PlessService.KYMW15 + 'updateCwsIconPublishOrder',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWSアイコンファイル適用期間更新
     */
    updateCwsIconFilePeriod: {
      url: PlessService.KYMW15 + 'updateCwsIconFilePeriod',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW16:画像確認画面
     */
    /**
     *  画像情報取得要求
     */
    KYMW16GetImageInfo: {
      url: PlessService.KYMW16 + 'getImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像情報詳細取得要求
     */
    KYMW16GetImageInfoDetail: {
      url: PlessService.KYMW16 + 'getImageInfoDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像使用可否更新・削除要求
     */
    KYMW16UpdateEnabledDelete: {
      url: PlessService.KYMW16 + 'updateEnabledDelete',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像情報更新要求
     */
    KYMW16UpdateImageInfo: {
      url: PlessService.KYMW16 + 'updateImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像ファイルURL取得要求
     */
    KYMW16GetImageFileUrl: {
      url: PlessService.KYMW16 + 'getImageFileUrl',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像ファイル差替要求
     */
    KYMW16ReplaceImageFile: {
      url: PlessService.KYMW16 + 'replaceImageFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像差換（アップロード）
     */
    KYMW16ReplaceImageFileUpload: {
      url: PlessService.KYMW16 + 'replaceImageFileUpload',
      showBusyCursor: true,
    },

    /**
     *  使用画像情報取得要求
     */
    KYMW16GetUseImageInfo: {
      url: PlessService.KYMW16 + 'getUseImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW17:画像作成管理
     */
    /**
     *  画像ファイル一覧取得要求
     */
    KYMW17GetImageInfo: {
      url: PlessService.KYMW17 + 'getImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像情報管理削除要求
     */
    KYMW17DeleteImageInfo: {
      url: PlessService.KYMW17 + 'deleteImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  撮影指示書PDF出力項目取得
     */
    KYMW17GetOrderingOutput: {
      url: PlessService.KYMW17 + 'getOrderingOutput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  参考資料ファイル情報取得
     */
    KYMW17GetReferenceImageOutput: {
      url: PlessService.KYMW17 + 'getReferenceImageOutput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像情報管理更新
     */
    KYMW17UpdateImageInfo: {
      url: PlessService.KYMW17 + 'updateImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  C2PFステータス更新
     */
    KYMW17UpdateC2pfStatus: {
      url: PlessService.KYMW17 + 'updateC2pfStatus',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像種類同期
     */
    KYMW17UpdateImageKind: {
      url: PlessService.KYMW17 + 'updateImageKind',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  サンプル発注書・撮影指示書PDF出力項目取得(KYMW1700)
     */
    KYMW17GetSampleOrderingOutput: {
      url: PlessService.KYMW17 + 'getSampleOrderingOutput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  撮影リストエクセル出力項目取得(KYMW1700)
     */
    KYMW17GetPhotoContentsListOutput: {
      url: PlessService.KYMW17 + 'getPhotoContentsListOutput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像個別登録
     */
    KYMW1704RegistImageSingle: {
      url: PlessService.KYMW17 + 'registImageSingle',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像ファイル差替要求
     */
    KYMW17ReplaceImageFile: {
      url: PlessService.KYMW17 + 'replaceImageFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像差換（アップロード）
     */
    KYMW17ReplaceImageFileUpload: {
      url: PlessService.KYMW17 + 'replaceImageFileUpload',
      showBusyCursor: true,
    },

    /**
     * 過去画像情報取得
     */
    getPastImageInfo: {
      url: PlessService.KYMW17 + 'getPastImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 過去画像情報登録
     */
    registPastImage: {
      url: PlessService.KYMW17 + 'registPastImage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 催促メール定型文取得処理
     */
    getRemindMailTemp: {
      url: PlessService.KYMW17 + 'getRemindMailTemp',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 催促メール情報送信
     */
    sendRemindMailInfo: {
      url: PlessService.KYMW17 + 'sendRemindMailInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 複数コード画像情報登録 (KYMW1708)
     */
    registMultipleCodeImageInfo: {
      url: PlessService.KYMW17 + 'registMultipleCodeImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * アップロード画像情報取得(KYMW1709)
     * 
     */
    getUploadImageInfo: {
      url: PlessService.KYMW17 + 'getUploadImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像チェックリスト
     */
    getImageExistenceList: {
      url: PlessService.KYMW18 + 'getImageExistenceList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声管理　掲載組合員の声出力データ件数取得
     */
    getMembersVoiceOutputNum: {
      url: PlessService.KYMW19 + 'getMembersVoiceOutputNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  組合員の声管理　掲載組合員の声データ出力
     */
    getMembersVoiceOutputCSV: {
      url: PlessService.KYMW19 + 'getMembersVoiceOutputCSV',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW21:注文コード設定
     */
    /**
     *  媒体情報取得
     */
    getCatalogProgressOfMedium: {
      url: PlessService.KYMW21 + 'getCatalogProgressOfMedium',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文コード一覧取得
     */
    getOrderNumList: {
      url: PlessService.KYMW21 + 'getOrderNumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  一括付番
     */
    updateIndiscriminatelyOrderNum: {
      url: PlessService.KYMW21 + 'updateIndiscriminatelyOrderNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文コード設定
     */
    updateIndividuallyOrderNum: {
      url: PlessService.KYMW21 + 'updateIndividuallyOrderNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW22:OCRデータメール送信
     */
    /**
     *  メールアドレス反映
     */
    updateMailAddress: {
      url: PlessService.KYMW22 + 'updateMailAddress',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  メール送信前チェック
     */
    checkSendOCRData: {
      url: PlessService.KYMW22 + 'checkSendOCRData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  メール送信
     */
    sendOCRData: {
      url: PlessService.KYMW22 + 'sendOCRData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW23:印刷会社用データ出力 START
     */
    /**
     *  ①ページ情報取得
     */
    KYMW23GetPageInfo: {
      url: PlessService.KYMW23 + 'getPageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ②工程履歴チェック
     */
    KYMW23CheckProgressHistory: {
      url: PlessService.KYMW23 + 'checkProgressHistory',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ③印刷会社用データの作成
     */
    KYMW23ExecutePrintCompanyData: {
      url: PlessService.KYMW23 + 'executePrintCompanyData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ③印刷会社用データの作成(サムネイル)
     */
    KYMW23ExecutePrintCompanyThumbnailData: {
      url: PlessService.KYMW23 + 'executePrintCompanyDataThumbnail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW23:印刷会社用データ出力 END
     */

    /**
     *  KYMW24:ページパターン設定
     */
    /**
     *  ページテンプレート一覧取得
     */
    getAllPageTemplate: {
      url: PlessService.KYMW24 + 'getAllPageTemplate',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページテンプレート情報取得
     */
    getPageTemplateInfoByPageTemplate: {
      url: PlessService.KYMW24 + 'getPageTemplateInfoByPageTemplate',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページテンプレート新規登録
     */
    registNewTemplate: {
      url: PlessService.KYMW24 + 'registNewTemplate',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページテンプレート更新
     */
    updateTemplate: {
      url: PlessService.KYMW24 + 'updateTemplate',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページテンプレート削除
     */
    deleteTemplate: {
      url: PlessService.KYMW24 + 'deleteTemplate',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW25:ページネーション設定
     */
    /**
     *  ページネーション設定一覧取得
     */
    getPageCopy: {
      url: PlessService.KYMW25 + 'getPageCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページネーション設定削除
     */
    deletePageCopyLine: {
      url: PlessService.KYMW25 + 'deletePageCopyLine',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページネーション詳細取得
     */
    getPagenationDetail: {
      url: PlessService.KYMW25 + 'getPagenationDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページネーション詳細設定
     */
    registPageCopy: {
      url: PlessService.KYMW25 + 'registPageCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページネーション情報出力
     */
    outputPagenationList: {
      url: PlessService.KYMW25 + 'outputPagenationList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW26:Ｗ掲載リスト
     */
    /**
     *  Ｗ掲載リスト取得
     */
    getWPlaceList: {
      url: PlessService.KYMW26 + 'getWPlaceList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  Ｗ掲載リスト親子入替
     */
    uploadWPlaceList: {
      url: PlessService.KYMW26 + 'uploadWPlaceList',
      showBusyCursor: true,
    },

    /**
     *  KYMW27:基版コピー・フェーズ管理画面
     */
    /**
     *  確定フェーズコンボ初期化
     */
    initFixationPhaseCombo: {
      url: PlessService.KYMW27 + 'initFixationPhaseCombo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  基版コピー一覧検索
     */
    getCatalogPageProgress: {
      url: PlessService.KYMW27 + 'getCatalogPageProgress',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  フェーズ検索
     */
    getCatalogPhaseInfo: {
      url: PlessService.KYMW27 + 'getCatalogPhaseInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  基版ページチェック
     */
    checkBaseKomaPublishing: {
      url: PlessService.KYMW27 + 'checkBaseKomaPublishing',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  全ページチェック
     */
    checkAllPage: {
      url: PlessService.KYMW27 + 'checkAllPage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  フェーズ確定
     */
    phaseFixation: {
      url: PlessService.KYMW27 + 'phaseFixation',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  基版コピー
     */
    copyBasePage: {
      url: PlessService.KYMW27 + 'copyBasePage',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  週別部門別供給高GP予算
     */
    outputGPBudgetProgressFile: {
      url: PlessService.KYMW28 + 'outputGPBudgetProgressFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  農産フロント連携
     */
    /**
     *  商品企画情報取込
     */
    registPlanGoodsInfo: {
      url: PlessService.KYMW29 + 'registPlanGoodsInfo',
      showBusyCursor: true,
    },

    /**
     *  産地コメント情報取込
     */
    updateProductionCenterComment: {
      url: PlessService.KYMW29 + 'updateProductionCenterComment',
      showBusyCursor: true,
    },

    /**
     *  CWS画像メンテ
     */
    /**
     *  画像ファイル一覧取得
     */
    getImageFileList: {
      url: PlessService.KYMW55 + 'getImageFileList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像ファイル更新
     */
    updateImageFileList: {
      url: PlessService.KYMW55 + 'updateImageFileList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS企画商品別カテゴリ設定一覧表
     */
    getCwsPlanGoodsCategoryList: {
      url: PlessService.KYMW58 + 'getCwsPlanGoodsCategoryList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS企画商品一覧表
     */
    getCwsPlanGoodsList: {
      url: PlessService.KYMW59 + 'getCwsPlanGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS使用画像一覧表
     */
    getCwsPlanGoodsUseImageList: {
      url: PlessService.KYMW60 + 'getCwsPlanGoodsUseImageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS使用画像一覧表(全体)
     */
    getCwsPlanGoodsUseImageGroupList: {
      url: PlessService.KYMW60 + 'getCwsPlanGoodsUseImageGroupList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS使用画像一覧表（新要件）
     */
    getCwsPlanGoodsUseImageGroupDispList: {
      url: PlessService.KYMW60 + 'getCwsPlanGoodsUseImageGroupDispList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS使用画像一覧表(新要件)
     */
    updateCheckStatus: {
      url: PlessService.KYMW60 + 'updateCheckStatus',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集情報取得
     */
    KYMW60getFeatureThemaList: {
      url: PlessService.KYMW60 + 'getFeatureThemaList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  CWS画像指示一覧表
     */
    getCwsUseImageInfo: {
      url: PlessService.KYMW61 + 'getCwsUseImageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS画像ファイル出力
     */
    putImageFile: {
      url: PlessService.KYMW61 + 'putImageFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  登録商品情報登録
     */
    /**
     *  タイムセールマスタ一覧
     */
    /**
     *  タイムセールマスタ情報取得
     */
    getCwsTimeSaleList: {
      url: PlessService.KYMW65 + 'getCwsTimeSaleList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タイムセールマスタ情報出力
     */
    saveCwsTimeSaleList: {
      url: PlessService.KYMW65 + 'saveCwsTimeSaleList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タイムセールマスタ情報取得
     */
    getCwsTimeSaleInfo: {
      url: PlessService.KYMW65 + 'getCwsTimeSaleInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タイムセールマスタ情報登録
     */
    registCwsTimeSaleInfo: {
      url: PlessService.KYMW65 + 'registCwsTimeSaleInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タイムセールマスタ情報更新
     */
    updateCwsTimeSaleInfo: {
      url: PlessService.KYMW65 + 'updateCwsTimeSaleInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タイムセールマスタ情報削除
     */
    deleteCwsTimeSaleInfo: {
      url: PlessService.KYMW65 + 'deleteCwsTimeSaleInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特別指示書
     */
    getIndicationList: {
      url: PlessService.KYMW66 + 'getIndicationList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  校正紙
     */
    getProofList: {
      url: PlessService.KYMW67 + 'getProofList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ECカテゴリ一覧取得
     */
    get68CategoryInfo: {
      url: PlessService.KYMW68 + 'getCategoryTree',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  ECカテゴリ変換マスタ一覧取得
    */
    getCategoryConvList: {
      url: PlessService.KYMW68 + 'getCategoryConvList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  ECカテゴリ変換マスタ情報取得
    */
    getCategoryConvInfo: {
      url: PlessService.KYMW68 + 'getCategoryConvInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  ECカテゴリ変換マスタ情報登録
    */
    registCategoryConvInfo: {
      url: PlessService.KYMW68 + 'registCategoryConvInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  タグ(ID)コンボボックス取得
    */
    KYMW68getTagList: {
      url: PlessService.KYMW68 + 'getTagList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集情報一覧取得
     */
    KYMW68getFeatureList: {
      url: PlessService.KYMW68 + 'getFeatureList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
    *  ECカテゴリ変換マスタ情報更新
    */
    updateCategoryConvInfo: {
      url: PlessService.KYMW68 + 'updateCategoryConvInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  ECカテゴリ変換マスタ情報削除
    */
    deleteCategoryConvInfo: {
      url: PlessService.KYMW68 + 'deleteCategoryConvInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  ECカテゴリ変換マスタ一覧出力
    */
    saveCwsCategoryConvList: {
      url: PlessService.KYMW68 + 'saveCategoryConvList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  変換区分リスト情報取得
     */
    KYMW68getConvDivList: {
      url: PlessService.KYMW68 + 'getConvDivList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /*
     *  KYMW69: 新規商品提案画面
     */
    /**
     *  提案者一覧取得
     */
    getProposalId: {
      url: PlessService.KYMW69 + 'getProposalId',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /*
     *  部門名商品担当者取得
     */
    getClassBuyerId: {
      url: PlessService.KYMW69 + 'getClassBuyerId',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /*
     *  商品提案情報取得
     */
    getGoodsProposalInfo: {
      url: PlessService.KYMW69 + 'getGoodsProposalInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  提案ステータス更新
     */
    updateSuggestionStatus: {
      url: PlessService.KYMW69 + 'updateSuggestionStatus',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  提案商品帳票出力項目取得 
     */
    getSuggestionGoodsOutput: {
      url: PlessService.KYMW69 + 'getSuggestionGoodsOutput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 新規商品提案情報取得
     */
    getNewGoodsProposalItem: {
      url: PlessService.KYMW69 + 'getNewGoodsProposalItem',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 一時保存時新商品提案情報登録
     */
    registNewGoodsProposal: {
      url: PlessService.KYMW69 + 'registNewGoodsProposal',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 一時保存時新商品提案情報更新
     */
    updateNewGoodsProposal: {
      url: PlessService.KYMW69 + 'updateNewGoodsProposal',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * イメージ写真ファイルアップロード
     */
    imagePhotoFileUpload: {
      url: PlessService.KYMW69 + 'imagePhotoFileUpload',
      showBusyCursor: true,
    },

    /**
     * イメージ写真ファイルダウンロード
     */
    imagePhotoDownload: {
      url: PlessService.KYMW69 + 'imagePhotodownload',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 提案ステータス採用更新
     */
    updateSuggestionStatusRecruiment: {
      url: PlessService.KYMW69 + 'updateSuggestionStatusRecruiment',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 提案ステータス不採用更新
     */
    updateSuggestionStatusRejected: {
      url: PlessService.KYMW69 + 'updateSuggestionStatusRejected',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 商品マスタ登録
     */
    registNewGoodsProposalGoods: {
      url: PlessService.KYMW69 + 'registNewGoodsProposalGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 新規商品提案情報取得
     */
    getNewGoodsProposal: {
      url: PlessService.KYMW69 + 'getNewGoodsProposal',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW71:束ね企画回設定
     */
    /**
     *  束ね企画媒体取得
     */
    getBundleCatalogMedium: {
      url: PlessService.KYMW71 + 'getBundleCatalogMedium',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },


    /**
     * 束ね企画回情報取得
     */
    getBundleCatalogRoundInfo: {
      url: PlessService.KYMW71 + 'getBundleCatalogRoundInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },


    /**
     *  束ね企画回情報登録
     */
    registBundleCatalogRoundInfo: {
      url: PlessService.KYMW71 + 'registBundleCatalogRoundInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  束ね企画回情報削除
     */
    deleteBundleCatalogRoundInfo: {
      url: PlessService.KYMW71 + 'deleteBundleCatalogRoundInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * マスタ入力表取得
     */
    getMasterInput: {
      url: PlessService.KYMW69 + 'getMasterInput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * マスタ入力表更新
     */
    updateMasterInput: {
      url: PlessService.KYMW69 + 'updateMasterInput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * マスタ入力表登録
     */
    registMasterInput: {
      url: PlessService.KYMW69 + 'registMasterInput',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 商品一覧取得
     */
    getGoodsList: {
      url: PlessService.KYMW69 + 'getGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    * 既存商品コピー
    */
    getExistingGoodsCopy: {
      url: PlessService.KYMW69 + 'getExistingGoodsCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW9000:ユーザ一覧画面
     */
    /**
     *  ユーザ一覧取得
     */
    getAssociatedUserManagementList: {
      url: PlessService.KYMW90 + 'getAssociatedUserManagementList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * ユーザ削除
     */
    deleteAssociatedUserManagement: {
      url: PlessService.KYMW90 + 'deleteAssociatedUserManagement',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * ユーザ区分取得
     */
    getAssociatedUserType: {
      url: PlessService.KYMW90 + 'getAssociatedUserType',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  権限コンボボックス
     */
    getAuthorityComboBoxValue: {
      url: PlessService.KYMW90 + 'getAuthorityComboBoxValue',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ユーザー情報詳細
     */
    getUserInfomationDetail: {
      url: PlessService.KYMW90 + 'getUserInfomationDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ユーザー登録
     */
    registUser: {
      url: PlessService.KYMW90 + 'registUser',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ユーザー更新
     */
    updateUser: {
      url: PlessService.KYMW90 + 'updateUser',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  権限セット情報詳細の初期表示
     */
    getAuthoritySetInfomationDetail: {
      url: PlessService.KYMW90 + 'getAuthoritySetInfomationDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /** KYMW9003 権限一覧 */
    /**
     *  権限セットリスト取得
     */
    getAuthoritySetList: {
      url: PlessService.KYMW90 + 'getAuthoritySetList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /** KYMW9004 権限設定 */
    /**
     * ユーザ権限情報取得
     */
    getAuthoritySetDetail: {
      url: PlessService.KYMW90 + 'getAuthoritySetDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  権限セット追加の初期表示
     */
    getFunctionList: {
      url: PlessService.KYMW90 + 'getFunctionList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  権限セット追加
     */
    registAuthoritySet: {
      url: PlessService.KYMW90 + 'registAuthoritySet',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  権限セット更新
     */
    updateAuthoritySet: {
      url: PlessService.KYMW90 + 'updateAuthoritySet',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW9005:ユーザ情報設定
     */
    /**
     * 関連会社ユーザ情報取得
     */
    getAssociatedUserManagementDetail: {
      url: PlessService.KYMW90 + 'getAssociatedUserManagementDetail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  関連会社ユーザ情報登録
     */
    registAssociatedUserManagement: {
      url: PlessService.KYMW90 + 'registAssociatedUserManagement',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 関連会社ユーザ情報更新
     */
    updateAssociatedUserManagement: {
      url: PlessService.KYMW90 + 'updateAssociatedUserManagement',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW9006
     * パスワード変更
     */
    updatePassword: {
      url: PlessService.KYMW90 + 'updatePassword',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW9009:ユーザ階層管理画面
     */
    /**
     *  ユーザ階層管理取得
     */
    getUserClassManagementList: {
      url: PlessService.KYMW90 + 'getUserClassManagementList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  Okta情報取得
     */
    getOktaInfomationList: {
      url: PlessService.KYMW90 + 'getOktaInfomationList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ユーザ階層管理更新
     */
    updateUserClassManagement: {
      url: PlessService.KYMW90 + 'updateUserClassManagement',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ユーザ階層管理削除
     */
    deleteUserClassManagement: {
      url: PlessService.KYMW90 + 'deleteUserClassManagement',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  Okta情報ユーザ名取得
     */
    getOktaUserName: {
      url: PlessService.KYMW90 + 'getOktaUserName',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },


    /**
     * 多要素認証処理
     */
    checkMfa: {
      url: PlessService.KYMW90 + 'checkMfa',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * パスワード再設定メール送信
     */
    sendPasswordResetEmail: {
      url: PlessService.KYMW90 + 'sendPasswordResetEmail',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW9010 関連会社一覧
     */
    /**
     * 関連会社一覧取得
     */
    getAssociatedCompanyList: {
      url: PlessService.KYMW90 + 'getAssociatedCompanyList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * KYMW9011 パスワード再設定入力
     */
    passwordReset: {
      url: PlessService.KYMW90 + 'passwordReset',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW91:ログ検索
     */
    /**
     *  ログ検索
     */
    getLogData: {
      url: PlessService.KYMW91 + 'getLogData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ログ出力
     */
    outputLogFile: {
      url: PlessService.KYMW91 + 'outputLogFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW92:企画回管理画面
     */
    /**
     *  企画回一覧情報取得
     */
    getCatalogInfoList: {
      url: PlessService.KYMW92 + 'getCatalogInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画カレンダー取込
     */
    importCatalogCalendar: {
      url: PlessService.KYMW92 + 'importCatalogCalendar',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW93:お知らせ編集画面
     */
    /**
     *  お知らせ取得
     */
    getInformations: {
      url: PlessService.KYMW93 + 'getInformations',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  お知らせ登録
     */
    registInformations: {
      url: PlessService.KYMW93 + 'registInformations',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW94:外部システム連携
     */
    /**
     *  営業カレンダー取込
     */
    importBusinessCalender: {
      url: PlessService.KYMW94 + 'importBusinessCalender',
      showBusyCursor: true,
    },

    /**
     *  利用予算人数取込
     */
    importUseNumPeople: {
      url: PlessService.KYMW94 + 'importUseNumPeople',
      showBusyCursor: true,
    },

    /**
     *  按分比率取込
     */
    importDistributionRatio: {
      url: PlessService.KYMW94 + 'importDistributionRatio',
      showBusyCursor: true,
    },

    /**
     *  予算取込
     */
    importBudget: {
      url: PlessService.KYMW94 + 'importBudget',
      showBusyCursor: true,
    },

    /**
     *  商品ロック登録
     */
    KYMW02registGoodsLock: {
      url: PlessService.KYMW02 + 'registGoodsLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品ロック解除
     */
    KYMW02releaseGoodsLock: {
      url: PlessService.KYMW02 + 'releaseGoodsLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品ロックチェック
     */
    KYMW02checkGoodsLock: {
      url: PlessService.KYMW02 + 'checkGoodsLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画商品ロック登録
     */
    KYMW02registPlanGoodsLock: {
      url: PlessService.KYMW02 + 'registPlanGoodsLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画商品ロック解除
     */
    KYMW02releasePlanGoodsLock: {
      url: PlessService.KYMW02 + 'releasePlanGoodsLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画ロック登録
     */
    KYMW02registCatalogLock: {
      url: PlessService.KYMW02 + 'registCatalogLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画ロック解除
     */
    KYMW02releaseCatalogLock: {
      url: PlessService.KYMW02 + 'releaseCatalogLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページロック登録
     */
    KYMW02registPageLock: {
      url: PlessService.KYMW02 + 'registPageLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページロック解除
     */
    KYMW02releasePageLock: {
      url: PlessService.KYMW02 + 'releasePageLock',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS add t-hayashi start ======================================
     */
    /**
     *  ■KYMW53:CWSカテゴリマスタ画面
     */

    /**
     *  カテゴリ情報取得
     */
    getCategoryInfo: {
      url: PlessService.KYMW53 + 'getCategoryInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  カテゴリ情報登録
     */
    registCategoryInfo: {
      url: PlessService.KYMW53 + 'registCategoryInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  カテゴリ情報更新
     */
    updateCategoryInfo: {
      url: PlessService.KYMW53 + 'updateCategoryInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  カテゴリ情報削除
     */
    deleteCategoryInfo: {
      url: PlessService.KYMW53 + 'deleteCategoryInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  カテゴリ表示順情報更新
     */
    updateCategoryShowSeqInfo: {
      url: PlessService.KYMW53 + 'updateCategoryShowSeqInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ■KYMW54:CWSカテゴリ関連マスタ画面
     */
    /**
     *  カテゴリ情報取得
     */
    get54CategoryInfo: {
      url: PlessService.KYMW54 + 'getCategoryInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  カテゴリ関連情報取得
     */
    getGoodsCategoryInfo: {
      url: PlessService.KYMW54 + 'getGoodsCategoryInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  カテゴリ関連情報更新
     */
    updateGoodsCategoryInfo: {
      url: PlessService.KYMW54 + 'updateGoodsCategoryInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS商品情報(商品一覧)取得
     */
    getCategoryCandidacyGoodsInfo: {
      url: PlessService.KYMW54 + 'getCategoryCandidacyGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  CWS add t-hayashi end   ======================================
     */

    /**
     *  週次プロモーション商品計画表出力処理
     */
    KYMW40outputPromotionPlanGoodsList: {
      url: PlessService.KYMW40 + 'outputPromotionPlanGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  週次プロモーションマスタ一覧取得処理
     */
    KYMW40getPromotionList: {
      url: PlessService.KYMW40 + 'getPromotionMasterList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  週次プロモーションマスタ一覧出力処理
     */
    KYMW40outputPromotionList: {
      url: PlessService.KYMW40 + 'outputPromotionMasterList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  プロモーションマスタ情報削除処理
     */
    KYMW40deletePromotionList: {
      url: PlessService.KYMW40 + 'deletePromotionMaster',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  プロモーションマスタ情報登録処理
     */
    KYMW40registPromotionList: {
      url: PlessService.KYMW40 + 'registPromotionMaster',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  プロモーションマスタ情報更新処理
     */
    KYMW40updatePromotionList: {
      url: PlessService.KYMW40 + 'updatePromotionMaster',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  統一企画点検リスト出力処理
     */
    KYMW41outputGoodsLayoutInspectList: {
      url: PlessService.KYMW41 + 'outputGoodsLayoutInspectList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  媒体間コマサイズ差分リスト出力
     */
    KYMW41outputKomaSizeDifferenceList: {
      url: PlessService.KYMW41 + 'outputKomaSizeDifferenceList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品マスタプルーフ候補一覧取得処理
     */
    KYMW42getCandidateGoodsProofList: {
      url: PlessService.KYMW42 + 'getCandidateGoodsProofList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品マスタプルーフ出力処理
     */
    KYMW42outputGoodsMasterProof: {
      url: PlessService.KYMW42 + 'outputGoodsMasterProof',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  週次プロモーション商品計画表用プロモーションマスタ取得
     */
    KYMW02getPromotionInfoList: {
      url: PlessService.KYMW02 + 'getPromotionInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品マスタＤＮＡデータ一覧出力
     */
    outputGoodsDNAList: {
      url: PlessService.KYMW43 + 'outputGoodsDNAList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品企画マスタＤＮＡデータ一覧出力
     */
    outputPlanGoodsDNAList: {
      url: PlessService.KYMW43 + 'outputPlanGoodsDNAList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  自動コマ配置用ページ一覧取得
     */
    getAutoArrangePageList: {
      url: PlessService.KYMW44 + 'getAutoArrangePageList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  自動コマ配置
     */
    registAutoKomaArrange: {
      url: PlessService.KYMW44 + 'registAutoKomaArrange',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  SAS週次企画データアップロード
     */
    uploadSasWeeklyPlanFile: {
      url: PlessService.KYMW44 + 'uploadSasWeeklyPlanFile',
      showBusyCursor: true,
    },

    /**
     *  SAS週次企画データアップロード続行指示
     */
    continueSasWeeklyPlanFiles: {
      url: PlessService.KYMW44 + 'continueSasWeeklyPlanFile',
      showBusyCursor: true,
    },

    /**
     *  タグ一覧取得
     */
    getTagList: {
      url: PlessService.KYMW46 + 'getTagList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タググループ一覧取得
     */
    getTagGroupList: {
      url: PlessService.KYMW46 + 'getTagGroupList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タグ一覧登録
     */
    registTagList: {
      url: PlessService.KYMW46 + 'registTagList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タググループ一覧登録
     */
    registTagGroupList: {
      url: PlessService.KYMW46 + 'registTagGroupList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タグ集約
     */
    aggregateTag: {
      url: PlessService.KYMW46 + 'aggregateTag',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タグPコード設定
     */
    setTagPCode: {
      url: PlessService.KYMW46 + 'setTagPCode',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },
    /**
     *  ページテンプレート選択項目取得
     */
    getPageTemplateSelectItems: {
      url: PlessService.KYMW44 + 'getPageTemplateSelectItems',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ユーザ管理選択項目取得
     */
    getUserManagementSelectItems: {
      url: PlessService.KYMW44 + 'getUserManagementSelectItems',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集情報選択項目取得
     */
    getFeatureThemaSelectItems: {
      url: PlessService.KYMW44 + 'getFeatureThemaSelectItems',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  掲載商品グループ選択項目取得
     */
    getPublishGoodsGroupSelectItems: {
      url: PlessService.KYMW44 + 'getPublishGoodsGroupSelectItems',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページ一覧取得
     */
    getPageInfoList: {
      url: PlessService.KYMW44 + 'getPageInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページ一覧登録
     */
    registPageInfoList: {
      url: PlessService.KYMW44 + 'registPageInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページ情報コピー
     */
    copyPageInfo: {
      url: PlessService.KYMW44 + 'copyPageInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  生協間ページ情報コピー
     */
    copyPageInfoToCoops: {
      url: PlessService.KYMW44 + 'copyPageInfoToCoops',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  ページ情報CSV出力
     */
    outputPageInfoCsv: {
      url: PlessService.KYMW44 + 'outputPageInfoCsv',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  自動コマ割パターン取得
     */
    getAutoKomaArrangePatternList: {
      url: PlessService.KYMW44 + 'getAutoKomaArrangePatternList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  マルチコード一覧取得
     */
    getMultiCodeList: {
      url: PlessService.KYMW47 + 'getMultiCodeList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  マルチ商品情報取得
     */
    getMultiGoods: {
      url: PlessService.KYMW47 + 'getMultiGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  マルチコード情報取得
     */
    getMultiCodeInfo: {
      url: PlessService.KYMW47 + 'getMultiCodeInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  候補商品情報取得
     */
    getCandidateGoods: {
      url: PlessService.KYMW47 + 'getCandidateGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  マルチ商品情報登録
     */
    registMultiGoods: {
      url: PlessService.KYMW47 + 'registMultiGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  マルチ商品情報削除
     */
    deleteMultiGoods: {
      url: PlessService.KYMW47 + 'deleteMultiGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  企画回コード取得
     */
    getDelivCatalogIdByOrderCode: {
      url: PlessService.KYMW70 + 'getDelivCatalogIdByOrderCode',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  受注コード取得
     */
    getOrderCodeByDelivCatalogId: {
      url: PlessService.KYMW70 + 'getOrderCodeByDelivCatalogId',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  受注コード部門リスト取得
     */
    getOrderCodeClassList: {
      url: PlessService.KYMW70 + 'getOrderCodeClassList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  受注コード媒体リスト取得
     */
    getOrderCodeMediumList: {
      url: PlessService.KYMW70 + 'getOrderCodeMediumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  特集商品提案状況一覧取得
     */
    getFeatureRequestStatusList: {
      url: PlessService.KYMW70 + 'getFeatureRequestStatusList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  特集商品提案状況一覧取得
     */
    getFeatureRequestList: {
      url: PlessService.KYMW70 + 'getFeatureRequestList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  依頼一覧情報取得（グループ長用）
     */
    getRequestInfoList: {
      url: PlessService.KYMW70 + 'getRequestInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  特集候補商品一覧情報取得
     */
    getFeatureCandidateGoodsList: {
      url: PlessService.KYMW70 + 'getFeatureCandidateGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  特集候補商品一覧情報更新
     */
    updateFeatureRequestBuyer: {
      url: PlessService.KYMW70 + 'updateFeatureRequestBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  依頼先バイヤー取得
     */
    getRequestBuyer: {
      url: PlessService.KYMW70 + 'getRequestBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  依頼一覧情報取得（担当バイヤー用）
     */
    getRequestListInfo: {
      url: PlessService.KYMW70 + 'getRequestListInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 商品選定済みフラグ確認結果取得処理
     */
    getSelectedGoodsFlgResult: {
      url: PlessService.KYMW70 + 'getSelectedGoodsFlgResult',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 提案候補商品一覧情報取得処理
     */
    getCandidateSuggestionGoodsList: {
      url: PlessService.KYMW70 + 'getCandidateSuggestionGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 承認フロー区分情報取得
     */
    getApprovalFlowTypeInfo: {
      url: PlessService.KYMW70 + 'getApprovalFlowTypeInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 提案商品情報一覧取得処理
     */
    getSuggestionGoodsListInfo: {
      url: PlessService.KYMW70 + 'getSuggestionGoodsListInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 提案商品情報取得処理
     */
    getSuggestionGoodsInfo: {
      url: PlessService.KYMW70 + 'getSuggestionGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 提案商品情報登録処理
     */
    registSuggestionGoodsInfo: {
      url: PlessService.KYMW70 + 'registSuggestionGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 提案商品一覧出力情報取得処理
     */
    getSuggestionGoodsListOutputInfo: {
      url: PlessService.KYMW70 + 'getSuggestionGoodsListOutputInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
    *  運営商品一覧取得
     */
    getOperationGoodsList: {
      url: PlessService.KYMW72 + 'getOperationGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  運営商品一覧削除
    */
    deleteOperationGoods: {
      url: PlessService.KYMW72 + 'deleteOperationGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  運営商品登録
     */
    registOperationGoods: {
      url: PlessService.KYMW72 + 'registOperationGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  運営商品取得
     */
    getOperationGoods: {
      url: PlessService.KYMW72 + 'getOperationGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  運営商品更新
     */
    updateOperationGoods: {
      url: PlessService.KYMW72 + 'updateOperationGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画確定済み媒体数取得
     */
    countFixtation: {
      url: PlessService.KYMW72 + 'countFixtation',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集情報取得処理(バイヤー)
     */
    getFeatureThemaByBuyer: {
      url: PlessService.KYMW70 + 'getFeatureThemaByBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報確定
     */
    confirmFeatureGoodsByBuyer: {
      url: PlessService.KYMW70 + 'confirmFeatureGoodsByBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報承認
     */
    approvalFeatureInfo: {
      url: PlessService.KYMW70 + 'approvalFeatureInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  選定依頼登録
     */
    registFeatureRequestBuyer: {
      url: PlessService.KYMW70 + 'registFeatureRequestBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  代替商品情報取得
     */
    getReplacementGoods: {
      url: PlessService.KYMW70 + 'getReplacementGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  商品情報取得(表紙特集掲載商品選定)
     */
    KYMW70getTargetListByFeatureGoodsSelection: {
      url: PlessService.KYMW70 + 'getTargetListByFeatureGoodsSelection',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  特集情報一覧取得
     */
    KYMW70getFeatureList: {
      url: PlessService.KYMW70 + 'getFeatureListByGoodsSelect',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報却下
     */
    rejectionFeatureInfo: {
      url: PlessService.KYMW70 + 'rejectionFeatureInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報却下
     */
    KYMW70getMediumListByOrder: {
      url: PlessService.KYMW70 + 'getMediumListByOrder',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  代替依頼商品情報取得
     */
    getReplacementRequestGoods: {
      url: PlessService.KYMW70 + 'getReplacementRequestGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  特集商品選定チェック
     */
    checkFeatureGoodsSelection: {
      url: PlessService.KYMW70 + 'checkFeatureGoodsSelection',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集選定商品一覧取得(バイヤー)
     */
    getSelectionGoodsListByBuyer: {
      url: PlessService.KYMW70 + 'getSelectionGoodsListByBuyer',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  差し替え対象一覧取得処理
     */
    getReplacementList: {
      url: PlessService.KYMW70 + 'getReplacementList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  商品計画数予測取得
     */
    KYMW70getGoodsPlanNum: {
      url: PlessService.KYMW70 + 'getGoodsPlanNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報ダウンロード
     */
    downloadFeatureGoods: {
      url: PlessService.KYMW70 + 'downloadFeatureGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報確定(企画担当)
     */
    confirmFeatureInfoByPlanner: {
      url: PlessService.KYMW70 + 'confirmFeatureInfoByPlanner',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報チェック
     */
    checkFeatureSelection: {
      url: PlessService.KYMW70 + 'checkFeatureSelection',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  商品基本情報取得
     */
    KYMW70getGoodsBase: {
      url: PlessService.KYMW70 + 'getGoodsBase',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  商品会員生協情報取得
     */
    KYMW70getGoodsCoop: {
      url: PlessService.KYMW70 + 'getGoodsCoop',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集商品選定情報保存(企画担当)
     */
    saveFeatureInfoByPlanner: {
      url: PlessService.KYMW70 + 'saveFeatureInfoByPlanner',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  特集情報取得
     */
    KYMW70getFeatureThema: {
      url: PlessService.KYMW70 + 'getFeatureThema',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集選定商品一覧取得
     */
    getSelectionGoodsList: {
      url: PlessService.KYMW70 + 'getSelectionGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  表紙特集選定依頼一覧取得
     */
    getSelectionRequestList: {
      url: PlessService.KYMW70 + 'getSelectionRequestList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  媒体一覧取得
     */
    KYMW48getMediumList: {
      url: PlessService.KYMW48 + 'getMediumList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     * 特集マスタ情報取得
     */
    getFeatureMasterInfo: {
      url: PlessService.KYMW45 + 'getFeatureMasterInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 特集マスタ情報更新
     */
    updateFeatureMasterInfo: {
      url: PlessService.KYMW45 + 'updateFeatureMasterInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 通知受領担当一覧取得
     */
    getNotificationUserList: {
      url: PlessService.KYMW45 + 'getNotificationUserList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 承認フロー区分一覧取得
     */
    getApprovalFlowList: {
      url: PlessService.KYMW45 + 'getApprovalFlowList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 固定特集情報マスタ取得
     */
    getFixFeatureForMasterInfo: {
      url: PlessService.KYMW45 + 'getFixFeatureForMasterInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 固定特集一覧取得
     */
    getFixFeature: {
      url: PlessService.KYMW45 + 'getFixFeature',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 特集コピー用媒体一覧取得
     */
    getMediumListForFeatureCopy: {
      url: PlessService.KYMW45 + 'getMediumListForFeatureCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 特集コピー実行
     */
    executeFeatureCopy: {
      url: PlessService.KYMW45 + 'executeFeatureCopy',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 企画確定フラグ取得
     */
    getCatalogFixFlag: {
      url: PlessService.KYMW45 + 'getCatalogFixFlag',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 媒体グループ区分取得
     */
    getMediumGroupDiv: {
      url: PlessService.KYMW45 + 'getMediumGroupDiv',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  バイヤークロス商品設定一覧取得
     */
    getBuyerCrossGoodsSetList: {
      url: PlessService.KYMW48 + 'getBuyerCrossGoodsSetList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  バイヤークロス商品設定マスタ一覧更新
     */
    updateBuyerCrossGoodsSetMasterList: {
      url: PlessService.KYMW48 + 'updateBuyerCrossGoodsSetMasterList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  クロスコード取得
     */
    getCrossCode: {
      url: PlessService.KYMW48 + 'getCrossCode',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  クロス商品情報一覧取得
     */
    getCrossGoodsInfoList: {
      url: PlessService.KYMW48 + 'getCrossGoodsInfoList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  Pコード商品情報取得
     */
    getPcodeGoodsInfo: {
      url: PlessService.KYMW48 + 'getPcodeGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  クロス設定削除
     */
    deleteCrossSet: {
      url: PlessService.KYMW48 + 'deleteCrossSet',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  クロス設定登録
     */
    registCrossSet: {
      url: PlessService.KYMW48 + 'registCrossSet',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  クロス設定更新
     */
    updateCrossSet: {
      url: PlessService.KYMW48 + 'updateCrossSet',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  商品未選定チェック
     */
    checkUnselectedGoods: {
      url: PlessService.KYMW48 + 'checkUnselectedGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  過去クロス商品設定一覧取得
     */
    getPastCrossGoodsSetList: {
      url: PlessService.KYMW48 + 'getPastCrossGoodsSetList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  対象クロス商品情報更新
     */
    updateTargetCrossGoodsInfo: {
      url: PlessService.KYMW48 + 'updateTargetCrossGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  注文単位値引クーポン一覧取得
     */
    getCouponList: {
      url: PlessService.KYMW73 + 'getCouponList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文単位値引クーポン一覧削除
     */
    deleteCouponList: {
      url: PlessService.KYMW73 + 'deleteCouponList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文単位値引クーポン情報取得
     */
    getCoupon: {
      url: PlessService.KYMW73 + 'getCoupon',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文単位値引クーポン情報更新
     */
    updateCoupon: {
      url: PlessService.KYMW73 + 'updateCoupon',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  注文単位値引クーポン情報新規追加
     */
    addCoupon: {
      url: PlessService.KYMW73 + 'addCoupon',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  受付期間取得
     */
    getReceiptCatalog: {
      url: PlessService.KYMW73 + 'getReceiptCatalog',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  画像検索画面初期状態取得
     */
    getKYMW0B00Init: {
      url: PlessService.KYMW0B + 'getKYMW0B00Init',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true
    },

    /**
     *  KYMW7400: 忘れず注文商品一覧取得
     */
    getRememberGoodsList: {
      url: PlessService.KYMW74 + 'getRememberGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW7400: 忘れず注文商品削除サービス
     */
    deleteRememberGoodsList: {
      url: PlessService.KYMW74 + 'deleteRememberGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW7400: 忘れず注文商品情報確定
     */
    confirmRememberGoods: {
      url: PlessService.KYMW74 + 'confirmRememberGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW7401: 忘れず注文商品対象選択 候補一覧取得
     */
    KYMW74getCandidateGoodsList: {
      url: PlessService.KYMW74 + 'getCandidateGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW7402: 忘れず注文商品登録
     */
    getGoodsCoopByItemCode: {
      url: PlessService.KYMW74 + 'getGoodsCoopByItemCode',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 企画確定受注コード一覧取得
     */
    getFixedOrderList: {
      url: PlessService.KYMW74 + 'getFixedOrderList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 忘れず注文商品情報取得
     */
    getRememberGoodsInfo: {
      url: PlessService.KYMW74 + 'getRememberGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 忘れず注文コード自動付番取得
     */
    getRememberOrderNum: {
      url: PlessService.KYMW74 + 'getRememberOrderNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 忘れず注文商品情報更新
     */
    updateRememberGoodsInfo: {
      url: PlessService.KYMW74 + 'updateRememberGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 忘れず注文商品情報更新(企画確定用)
     */
    updateRememberGoodsInfoForFixed: {
      url: PlessService.KYMW74 + 'updateRememberGoodsInfoForFixed',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 企画進捗管理最古企画情報取得
     */
    getOldCatalogProgressCatalogInfo: {
      url: PlessService.KYMW74 + 'getOldCatalogProgressCatalogInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 忘れず注文出力対象取得
     */
    getOutputTarget: {
      url: PlessService.KYMW74 + 'getOutputTarget',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 忘れず注文商品リスト出力
     */
    outputRememberGoodsInfo: {
      url: PlessService.KYMW74 + 'outputRememberGoodsInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     * 忘れず注文商品差分出力
     */
    outputRememberGoodsDiff: {
      url: PlessService.KYMW74 + 'outputRememberGoodsDiff',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  KYMW75: 計画数確認
     */
    /**
     *  企画商品特集情報取得
     */
    getPlanGoodsFeature: {
      url: PlessService.KYMW75 + 'getPlanGoodsFeature',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  計画数確認商品一覧取得
     */
    getGoodsListForCheckPlanNum: {
      url: PlessService.KYMW75 + 'getGoodsListForCheckPlanNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  計画数確認更新
     */
    updateCheckPlanNum: {
      url: PlessService.KYMW75 + 'updateCheckPlanNum',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  企画商品基本マスタ受注コード一覧取得
     */
    kymw75GetCatalogInfo: {
      url: PlessService.KYMW75 + 'getCatalogInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  候補リスト(KYMW11)
     */
    KYMW11getCandidateGoodsList: {
      url: PlessService.KYMW11 + 'getCandidateGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
    *  候補リスト出力(KYMW11)
    */
    KYMW11makeCandidateGoodsFile: {
      url: PlessService.KYMW11 + 'makeCandidateGoodsFile',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  コープ商品URL取込
     */
    updateCoopGoodsUrlData: {
      url: PlessService.KYMW11 + 'updateCoopGoodsUrlData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  旧商品タグ情報取得
     */
    getOldGoodsTagList: {
      url: PlessService.KYMW11 + 'getOldGoodsTagList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  タグ情報取得
     */
    getTagInfo: {
      url: PlessService.KYMW11 + 'getTagInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  掲載媒体情報取得（KYMW11）
     */
    KYMW11getPublishMediumInfo: {
      url: PlessService.KYMW11 + 'getPublishMediumInfo',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  コープ商品URL取得
     */
    getCoopGoodsUrlData: {
      url: PlessService.KYMW11 + 'getCoopGoodsUrlData',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  商品ECカテゴリ情報リストを取得
     */
    getEcCategory: {
      url: PlessService.KYMW11 + 'getEcCategory',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集商品提案状況一覧更新
     */
    updateFeatureRequestList: {
      url: PlessService.KYMW70 + 'updateFeatureRequestList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集一覧取得
     */
    getFeatureList: {
      url: PlessService.KYMW70 + 'getFeatureList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集一覧取得
     */
    getFeatureGoods: {
      url: PlessService.KYMW70 + 'getFeatureGoods',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

    /**
     *  特集一覧取得
     */
    updateFeatureGoodsList: {
      url: PlessService.KYMW70 + 'updateFeatureGoodsList',
      method: 'POST',
      contentType: 'application/json',
      showBusyCursor: true,
    },

  };
}
